import { Drawer, useMediaQuery } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeSidebar } from "store/slices/SidebarDrawer.slice";

const SidebarDrawer = () => {
  const { isOpen, content } = useSelector((state) => state.sidebar);
  const dispatch = useDispatch();
  const isMdDown = useMediaQuery("(max-width:900px)");

  useEffect(() => {
    dispatch(closeSidebar());
  }, [dispatch]);

  const onClose = () => {
    dispatch(closeSidebar());
  };

  return isMdDown ? (
    <Drawer open={isOpen} onClose={onClose}>
      {content}
    </Drawer>
  ) : null;
};

export default SidebarDrawer;
